import React from "react";

export default function GoldLoanSuccess({ setCurrentStep, selectedOffer }) {
  const lenderName = selectedOffer?.lender_name || "Our Partner";
  
  return (
    <div className="w-full max-w-[400px] mx-auto bg-[#fcfcfc] min-h-[100dvh] flex flex-col font-atkinson">
      
      <div className="px-5 pt-6 pb-2">
        <button onClick={() => setCurrentStep(4)} className="w-8 h-8 flex items-center justify-center">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1b1b1b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
      </div>

      <div className="px-5 mt-2 flex-1">
        <h1 className="text-[28px] font-bold text-[#1b1b1b]">Thank You!</h1>
        <h2 className="text-[15px] font-bold text-[#1b1b1b] mt-4">
          Your <span className="text-[#C69A27]">Gold Loan</span> request has been received
        </h2>
        <p className="text-[13px] text-[#6b6b6b] mt-3 leading-relaxed pr-4">
          We've received your request. Our partner will help you with the next steps for your Gold Loan.
        </p>

        <div className="w-full h-[1px] bg-[#e8e8e8] my-6"></div>

        <div className="bg-[#EBFBF4] rounded-[16px] p-5 border border-[#D1EFE2]">
          <div className="text-[11px] font-bold text-[#5c7a6b] tracking-wider mb-3 uppercase">
            Your Nearest Branch
          </div>
          
          {/* 👇 The dynamic lender name is now correctly placed here */}
          <div className="font-bold text-[14px] text-[#1b1b1b] mb-2">
            {lenderName} Gold Loan
          </div>
          
          <p className="text-[12px] text-[#4a5c53] leading-relaxed">
            2nd Floor, JK Chambers Building, 203 & 204, P No.76, nr. Golden Punjab Hotel, Sector 17, Vashi, Navi Mumbai, Maharashtra 400703
          </p>
          <div className="text-[12px] text-[#658574] mt-3 mb-5">
            2.4 km away
          </div>

          <button className="w-full bg-white text-[#1b1b1b] font-bold text-[15px] rounded-[12px] py-3 border border-[#d0e6dc] shadow-sm flex items-center justify-center gap-2 active:scale-[0.98] transition-transform">
            Get Directions
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        </div>
      </div>

      <div className="px-5 pb-8 pt-4 bg-[#fcfcfc]">
        <button 
          onClick={() => setCurrentStep(1)} 
          className="w-full bg-black text-white font-bold text-[16px] rounded-[14px] py-[18px] active:scale-[0.98] transition-transform"
        >
          Back to home
        </button>
        <p className="text-center text-[#a0a0a0] text-[11px] mt-4">We're here to help!</p>
      </div>
    </div>
  );
}